import './NoAuthRoute.scss';
import React from 'react';
import { Navigate } from 'react-router';
import Helpers from '../../js/helpers';
import config from '../../js/config/_global';
import Alert from '../alert/Alert';

type NoAuthRouteProps = {
  component: React.ComponentType<any>;
};

const NoAuthRoute = ({ component: Component }: NoAuthRouteProps) => {
  const renderInnerComponent = () =>
    Component ? React.createElement(Component) : null;

  if (Helpers.isAuthenticated()) {
    return <Navigate to={config.defaultUrls.authenticated} replace />;
  }

  return (
    <div className="app-container">
      {renderInnerComponent()}
      <Alert />
    </div>
  );
};

export default NoAuthRoute;
